module.exports = __webpack_public_path__ + "static/media/2019-2020-New-S-and-E-Event-Codes.f2799aa5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/19-20/2019-2020-New-S-and-E-Event-Codes.pdf
// module id = 201
// module chunks = 0